import { phone } from 'phone';
import { z } from 'zod';
import { requiredOr } from '../utils/required-error.util.mjs';

const encrypted = (schema) => schema.brand();
const decrypted = (schema) => schema.brand();
const hashed = (schema) => schema.brand();
const uuid = z.uuid().brand();
const entityId = uuid.brand();
const agencyId = entityId.brand();
const suretyBondFormTemplateId = entityId.brand();
const suretyBondFormFileUploadId = entityId.brand();
const suretyQuoteDraftBondFormFileUploadId = entityId.brand();
const carrierAgencyRelationshipId = entityId.brand();
const suretyBondNumberCounterId = entityId.brand();
const suretyBondNumberCacheId = entityId.brand();
const suretyCarrierPoaId = entityId.brand();
const suretyIndemnityAgreementId = entityId.brand();
const suretyBondFormId = entityId.brand();
const bidSuretyBondFormId = entityId.brand();
const contractSuretyBondFormId = entityId.brand();
const eSignatureId = entityId.brand();
const eSignatureVendorId = entityId.brand();
const attachmentId = entityId.brand();
const fileUploadId = entityId.brand();
const fileId = entityId.brand();
const filePreviewId = entityId.brand();
const individualContactId = entityId.brand();
const companyContactId = entityId.brand();
const workInProgressStatementId = entityId.brand();
const individualCreditReportId = entityId.brand();
const individualOFACCheckId = entityId.brand();
const companyCreditReportId = entityId.brand();
const indemnificationId = entityId.brand();
const suretyAccountUnderwritingId = entityId.brand();
const suretyAccountCarrierBondingLineId = entityId.brand();
const suretyAccountBondingLineId = entityId.brand();
const bondingLinesVersion = z.string().min(1).max(128).brand();
const suretyAccountAllowedCarrierId = entityId.brand();
const suretyCompanyBondingLineId = entityId.brand();
const suretyAccountId = entityId.brand();
const suretyQuoteId = entityId.brand();
const suretyBondIssuanceId = entityId.brand();
const bidSuretyBondIssuanceId = entityId.brand();
const contractSuretyBondIssuanceId = entityId.brand();
const suretyBondId = entityId.brand();
const bidSuretyBondId = entityId.brand();
const contractSuretyBondId = entityId.brand();
const suretyBondPeriodId = entityId.brand();
const suretyBondTermId = entityId.brand();
const suretyBondTermAdjustmentId = entityId.brand();
const suretyBondRenewalPeriodTemplateId = entityId.brand();
const eventId = entityId.brand();
const suretyAccountReviewReasonId = entityId.brand();
const suretyQuoteReviewReasonId = entityId.brand();
const commentId = entityId.brand();
const followerId = entityId.brand();
const userId = entityId.brand();
const noteId = entityId.brand();
const noteTopicId = entityId.brand();
const actionItemId = entityId.brand();
const proConId = entityId.brand();
const decisioningFactorId = entityId.brand();
const decisioningFactorGroupId = entityId.brand();
const proConRelationshipId = entityId.brand();
const dataNeededId = entityId.brand();
const decisionId = entityId.brand();
const actionItemToEntityId = entityId.brand();
const noteTopicHistoryId = entityId.brand();
const noteHistoryId = entityId.brand();
const contractProcessingId = entityId.brand();
const suretyQuoteUnderwritingId = entityId.brand();
const tagId = entityId.brand();
const tagDisplayNameSchema = z.string().min(1).max(30).trim();
const entityTagId = entityId.brand();
const financialPeriodId = entityId.brand();
const balanceSheetId = entityId.brand();
const incomeStatementId = entityId.brand();
const financialExtractionId = entityId.brand();
const contractExtractionId = entityId.brand();
const bondRequestExtractionId = entityId.brand();
const applicationExtractionId = entityId.brand();
const assistantConversationId = entityId.brand();
const assistantMessageId = entityId.brand();
const assistantToolCallId = entityId.brand();
const assistantFeedbackId = entityId.brand();
const assistantSpecVersionId = entityId.brand();
const assistantChartImageId = uuid.brand();
const assistantChartDataId = uuid.brand();
const emailSubmissionId = entityId.brand();
const emailSubmissionThreadExtractionId = entityId.brand();
const emailSubmissionConversionId = entityId.brand();
const workInProgressScheduleExtractionId = entityId.brand();
const wipStatementId = entityId.brand();
const wipProjectId = entityId.brand();
const wipLineItemId = entityId.brand();
const documentId = entityId.brand();
const sessionId = entityId.brand();
const pageId = entityId.brand();
const runnerId = entityId.brand();
const errorId = entityId.brand();
const naicsCodeId = entityId.brand();
const suretyAccountNaicsCodeId = entityId.brand();
const sfaaCodeId = entityId.brand();
const sfaaClassExperienceImportId = entityId.brand();
const sfaaClassExperienceId = entityId.brand();
const fredSeriesId = entityId.brand();
const fredObservationId = entityId.brand();
const fredSyncRunId = entityId.brand();
const fredSeriesCode = z.string().min(1).max(64).brand();
const entityName = z.string().brand();
const carrierName = entityName.brand();
const authzId = z.string().brand();
const rateSchema = z.coerce
    .number({
    error: (iss) => (!iss.input ? "Required" : iss.message),
})
    .min(0)
    .lt(1)
    .transform((val) => {
    const segments = val.toString().split(".");
    return parseFloat(`${segments[0]}.${segments[1]?.slice(0, 7)}`);
})
    .brand();
const rateSchemaV2 = z
    .number()
    .min(0)
    .lt(1)
    .transform((val) => Math.round(val * 1e7) / 1e7)
    .brand();
const percentSchema = z.coerce
    .number({
    error: (iss) => (!iss.input ? "Required" : iss.message),
})
    .min(0)
    .max(1)
    .multipleOf(0.001)
    .brand();
const percentSchemaV2 = z.number().min(0).max(1).multipleOf(0.001).brand();
const email = z
    .string()
    .toLowerCase()
    .email({ error: requiredOr("Invalid Email") })
    .brand();
const firstName = z.string().brand();
const lastName = z.string().brand();
const npn = z.string().brand();
const toValidPhoneNumber = (val) => {
    if (typeof val !== "string" && typeof val !== "number")
        return undefined;
    const result = phone(String(val));
    return result.isValid ? result.phoneNumber : undefined;
};
const phoneNumber = z
    .preprocess((val) => toValidPhoneNumber(val) ?? val, z.custom((val) => toValidPhoneNumber(val) !== undefined, {
    error: requiredOr("Invalid Phone Number"),
}))
    .brand();
const ssn = z.string().brand();
const decryptedSSN = decrypted(z
    .string()
    .regex(/[0-9]*\d{9}$/, { error: requiredOr("Invalid SSN") })
    .brand());
const fein = z
    .string()
    .trim()
    .regex(/^[0-9]*$/, "Must be a number")
    .max(15, "Max 15 digits")
    .brand();
const slackId = z.string().brand();
const formatSlackMention = (slackId) => slackId.startsWith("S") ? `<!subteam^${slackId}|handle>` : `<@${slackId}>`;
const creditReportPermissionSchema = z.object({
    id: z.uuid(),
    permission: z.literal(true),
});
const isoDateSchema = z.preprocess((val) => (typeof val === "string" ? val.split("T")[0] : val), z.iso.date().brand());
const isoDateTimeSchema = z.iso.datetime().brand();
const days = z.number().brand();
const weeks = z.number().brand();
const months = z.number().brand();
const years = z.number().brand();
const calendarDay = z.object({
    month: z.number().min(1).max(12),
    day: z.number().min(1).max(31),
});
const timePeriodSchema = z.object({
    days: days.nullish(),
    weeks: weeks.nullish(),
    months: months.nullish(),
    years: years.nullish(),
});
const streetAddress = z.string().brand();
const city = z.string().brand();
const zipCode = z.string().brand();
var GoogleMaps;
(function (GoogleMaps) {
    (function (AddressComponentsEntityConfirmationLevel) {
        AddressComponentsEntityConfirmationLevel["CONFIRMED"] = "CONFIRMED";
        AddressComponentsEntityConfirmationLevel["UNCONFIRMED_BUT_PLAUSIBLE"] = "UNCONFIRMED_BUT_PLAUSIBLE";
        AddressComponentsEntityConfirmationLevel["UNCONFIRMED_AND_SUSPICIOUS"] = "UNCONFIRMED_AND_SUSPICIOUS";
    })(GoogleMaps.AddressComponentsEntityConfirmationLevel || (GoogleMaps.AddressComponentsEntityConfirmationLevel = {}));
})(GoogleMaps || (GoogleMaps = {}));
const fsr = z.number().positive().min(1).max(999).brand();
const fico = z.number().positive().min(1).max(999).brand();
var ProductType;
(function (ProductType) {
    ProductType["SURETY"] = "surety";
})(ProductType || (ProductType = {}));
var EnvironmentName;
(function (EnvironmentName) {
    EnvironmentName["local"] = "local";
    EnvironmentName["production"] = "production";
    EnvironmentName["qa"] = "qa";
    EnvironmentName["test"] = "test";
    EnvironmentName["ci-cd"] = "ci-cd";
    EnvironmentName["demo"] = "demo";
})(EnvironmentName || (EnvironmentName = {}));
const environmentNameSchema = z.enum(EnvironmentName);

export { EnvironmentName, GoogleMaps, ProductType, actionItemId, actionItemToEntityId, agencyId, applicationExtractionId, assistantChartDataId, assistantChartImageId, assistantConversationId, assistantFeedbackId, assistantMessageId, assistantSpecVersionId, assistantToolCallId, attachmentId, authzId, balanceSheetId, bidSuretyBondFormId, bidSuretyBondId, bidSuretyBondIssuanceId, bondRequestExtractionId, bondingLinesVersion, calendarDay, carrierAgencyRelationshipId, carrierName, city, commentId, companyContactId, companyCreditReportId, contractExtractionId, contractProcessingId, contractSuretyBondFormId, contractSuretyBondId, contractSuretyBondIssuanceId, creditReportPermissionSchema, dataNeededId, days, decisionId, decisioningFactorGroupId, decisioningFactorId, decrypted, decryptedSSN, documentId, eSignatureId, eSignatureVendorId, email, emailSubmissionConversionId, emailSubmissionId, emailSubmissionThreadExtractionId, encrypted, entityId, entityName, entityTagId, environmentNameSchema, errorId, eventId, fein, fico, fileId, filePreviewId, fileUploadId, financialExtractionId, financialPeriodId, firstName, followerId, formatSlackMention, fredObservationId, fredSeriesCode, fredSeriesId, fredSyncRunId, fsr, hashed, incomeStatementId, indemnificationId, individualContactId, individualCreditReportId, individualOFACCheckId, isoDateSchema, isoDateTimeSchema, lastName, months, naicsCodeId, noteHistoryId, noteId, noteTopicHistoryId, noteTopicId, npn, pageId, percentSchema, percentSchemaV2, phoneNumber, proConId, proConRelationshipId, rateSchema, rateSchemaV2, runnerId, sessionId, sfaaClassExperienceId, sfaaClassExperienceImportId, sfaaCodeId, slackId, ssn, streetAddress, suretyAccountAllowedCarrierId, suretyAccountBondingLineId, suretyAccountCarrierBondingLineId, suretyAccountId, suretyAccountNaicsCodeId, suretyAccountReviewReasonId, suretyAccountUnderwritingId, suretyBondFormFileUploadId, suretyBondFormId, suretyBondFormTemplateId, suretyBondId, suretyBondIssuanceId, suretyBondNumberCacheId, suretyBondNumberCounterId, suretyBondPeriodId, suretyBondRenewalPeriodTemplateId, suretyBondTermAdjustmentId, suretyBondTermId, suretyCarrierPoaId, suretyCompanyBondingLineId, suretyIndemnityAgreementId, suretyQuoteDraftBondFormFileUploadId, suretyQuoteId, suretyQuoteReviewReasonId, suretyQuoteUnderwritingId, tagDisplayNameSchema, tagId, timePeriodSchema, userId, uuid, weeks, wipLineItemId, wipProjectId, wipStatementId, workInProgressScheduleExtractionId, workInProgressStatementId, years, zipCode };
